import ForgotPassword from './ForgotPassword'
import ForgotPasswordVerification from './ForgotPasswordVerification'
import ChangePassword from './ChangePassword'
import ChangePasswordConfirm from './ChangePasswordConfirm'

const PasswordComponents = {
  ForgotPassword,
  ForgotPasswordVerification,
  ChangePassword,
  ChangePasswordConfirm,
}

export default PasswordComponents
